function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.03 12.0171C23.03 11.1839 22.9552 10.3828 22.8164 9.61371H11.75V14.1588H18.0736C17.8012 15.6276 16.9734 16.872 15.729 17.7052V20.6534H19.5264C21.7482 18.6078 23.03 15.5955 23.03 12.0171Z",
  fill: "#4285F4"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.75 23.5C14.9225 23.5 17.5823 22.4478 19.5263 20.6533L15.729 17.7051C14.6768 18.4101 13.3309 18.8267 11.75 18.8267C8.68964 18.8267 6.0993 16.7598 5.17532 13.9825H1.24976V17.0268C3.18316 20.8669 7.1568 23.5 11.75 23.5Z",
  fill: "#34A853"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.17534 13.9825C4.94034 13.2775 4.80682 12.5244 4.80682 11.75C4.80682 10.9755 4.94034 10.2225 5.17534 9.51746V6.47314H1.24977C0.453977 8.05939 0 9.85394 0 11.75C0 13.646 0.453977 15.4405 1.24977 17.0268L5.17534 13.9825Z",
  fill: "#FBBC05"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.75 4.6733C13.4751 4.6733 15.024 5.26614 16.2417 6.43045L19.6118 3.06034C17.5769 1.16432 14.9171 0 11.75 0C7.1568 0 3.18317 2.63307 1.24976 6.47318L5.17532 9.5175C6.0993 6.74023 8.68964 4.6733 11.75 4.6733Z",
  fill: "#EA4335"
});

var SvgGoogleIcon = function SvgGoogleIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGoogleIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/googleIcon.c3fffbca.svg";
export { ForwardRef as ReactComponent };